
import { RevContainer } from '@ds/components/Container'
import isEmpty from 'lodash/isEmpty'

import CustomContent from '../CustomContent/CustomContent.vue'
import FeaturedArticles from '../FeaturedArticles/FeaturedArticles.vue'
import Reassurance from '../Reassurance/Reassurance.vue'
import SuggestedComparisons from '../SuggestedComparisons/SuggestedComparisons.vue'

export default {
  components: {
    CustomContent,
    FeaturedArticles,
    Reassurance,
    RevContainer,
    SuggestedComparisons,
  },

  props: {
    content: {
      type: Object,
      default: () => ({
        customContent: {},
        featuredArticles: [],
        suggestedComparisons: [],
      }),
    },
  },
  computed: {
    // [ACQ-856] API change in progress: `content` is becoming
    // `body`. We need to support both in between.
    temporaryBody() {
      return (
        this.content.customContent.body || this.content.customContent.content
      )
    },
    hasCustomContent() {
      return !isEmpty(this.content.customContent)
    },
    hasFeaturedArticles() {
      return !isEmpty(this.content.featuredArticles)
    },
    hasSuggestedComparisons() {
      return !isEmpty(this.content.suggestedComparisons)
    },
    hasComparisonResults() {
      return (
        !isEmpty(this.$route.params.productA) &&
        !isEmpty(this.$route.params.productB)
      )
    },
  },
}
